import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a36c60c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "fixed-content"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "pic"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = ["onMouseover", "onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "回到顶部", -1));
import { reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { $track } from '@/plugins/Track';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const csName = ref('');
    const source = ref('落地页');
    let datalist = reactive([{
      title: '400-6868-860',
      mtitle: '电话咨询',
      desc: '官方电话',
      csName: 'phone'
    }, {
      title: '免费试用',
      mtitle: '免费试用',
      desc: '',
      csName: 'ontrial'
    }, {
      title: '微信小程序',
      mtitle: '扫码体验',
      desc: '请用微信扫描二维码',
      csName: 'code',
      imgSrc: require('./img/qbq-code.jpg')
    }]);
    watch(() => router.currentRoute.value.path, toPath => {
      if (route.meta.name === 'eputin') {
        datalist = datalist.filter(item => item.csName !== 'code');
        csName.value = 'min';
        source.value = '电子档案_落地页';
      }
    }, {
      immediate: true,
      deep: true
    });
    const trackOver = name => {
      const obj = {
        phone: '电话咨询',
        ontrial: '免费试用',
        code: '扫码体验'
      };
      // 上报用户行为
      $track('WebUserClick', {
        button_name: `悬浮_${obj[name]}`,
        click_info: obj[name],
        event_source: source.value,
        event_target: obj[name],
        event_target_pam: null,
        event_source_pam: null
      });
    };
    const callMethod = name => {
      if (name === 'ontrial') {
        sessionStorage.setItem('source', '悬浮_免费试用');
        return window.scrollTo({
          top: 60,
          left: 0,
          behavior: 'smooth'
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_back_top = _resolveComponent("a-back-top");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["fixedbar", csName.value])
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(datalist), (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.csName !== 'ontrial' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 0,
          placement: "left",
          color: "white",
          getPopupContainer: terget => terget.parentNode.parentNode
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            class: "pop-content",
            onClick: $event => callMethod(item.csName)
          }, [item.imgSrc ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
            src: item.imgSrc
          }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.desc), 1)], 8, _hoisted_2)]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["item", item.csName]),
            onMouseover: $event => trackOver(item.csName),
            onClick: $event => callMethod(item.csName)
          }, _toDisplayString(item.mtitle), 43, _hoisted_6)]),
          _: 2
        }, 1032, ["getPopupContainer"])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["item", item.csName]),
          onClick: $event => callMethod(item.csName)
        }, _toDisplayString(item.mtitle), 11, _hoisted_7))], 64);
      }), 256))]), _createVNode(_component_a_back_top, {
        class: "gotop"
      }, {
        default: _withCtx(() => [_hoisted_8]),
        _: 1
      })], 2);
    };
  }
};